
import list from "./list"
import show from "./show"
import create from "./create"
import update from "./update"
import del from "./del"
import reply from "./reply"
export default  {
    namespaced:true,
    modules:{
        list,
        show,
        reply,
        del,
        create,
        update,
    }
}